import React from "react";
import Select from "react-select";
import ReactFormat from "react-number-format";
import { Button, Col, Input, Label, Row, TabPane } from "reactstrap";
import ReactTable from "@dhn/components/molecules/data-table";
import Money from "../components/Money";

const optionLabel = (option) =>
  option.hasCoverage
    ? option.product.name
    : `${option.product.name} (sin cobertura para la ARS)`;

export default function NewQuote({
  quotationsDetails,
  serviceOptions,
  loadingServiceOptions,
  onAddService,
  onRemoveService,
  onChangeQuantity,
  isPageModalHistory,
}) {
  return (
    <TabPane tabId={1}>
      <div className="animated fadeIn">
        <Row form className="mb-4" hidden={isPageModalHistory}>
          <Col md={4}>
            <Label>Servicios de Salud:</Label>
            <Select
              classNamePrefix="dhn-select"
              placeholder="Seleccionar servicio"
              options={serviceOptions}
              value={null}
              isLoading={loadingServiceOptions}
              loadingMessage={() => "Cargando servicios..."}
              noOptionsMessage={() => "No hay servicios disponibles para cotizar"}
              getOptionValue={(option) => String(option.product.id)}
              getOptionLabel={optionLabel}
              isOptionDisabled={(option) => !option.hasCoverage}
              onChange={onAddService}
            />
          </Col>
        </Row>
        <Row form>
          <Col>
            <ReactTable
              data={quotationsDetails}
              defaultPageSize={5}
              noDataText="No hay servicios en la cotización"
              className="-striped -highlight"
              columns={[
                {
                  Header: "Servicio",
                  width: 400,
                  accessor: "product.name",
                },
                {
                  Header: "Cantidad",
                  className: "p-1",
                  width: 120,
                  Cell: ({ original }) => (
                    <ReactFormat
                      className="text-right"
                      style={{ height: 27 }}
                      thousandSeparator={true}
                      placeholder="0"
                      value={original?.quantity || ""}
                      customInput={Input}
                      allowNegative={false}
                      disabled={isPageModalHistory}
                      onValueChange={({ floatValue }) =>
                        onChangeQuantity(original?.product?.id, floatValue)
                      }
                    />
                  ),
                },
                {
                  Header: "Tarifa",
                  className: "text-right",
                  Cell: ({ original }) => (
                    <Money
                      value={original?.insuredContrated || original?.consultoryFee}
                    />
                  ),
                },
                {
                  Header: "Cobertura",
                  className: "text-right",
                  Cell: ({ original }) => <Money value={original?.insuredCoverage} />,
                },
                {
                  Header: "Diferencia",
                  className: "text-right",
                  Cell: ({ original }) => (
                    <Money value={original?.consultoryDifferent} />
                  ),
                },
                {
                  Header: "Valor",
                  className: "text-right",
                  Cell: ({ original }) => (
                    <Money
                      value={
                        (Number(original?.consultoryDifferent) || 0) *
                        (Number(original?.quantity) || 0)
                      }
                    />
                  ),
                },
                {
                  Header: "Opciones",
                  className: "text-center",
                  show: !isPageModalHistory,
                  Cell: ({ original }) => (
                    <Button
                      color="danger"
                      type="button"
                      className="btn-color-danger card-header-action"
                      onClick={() => onRemoveService(original?.product?.id)}
                    >
                      <i className="fa fa-trash" />
                      {" Borrar"}
                    </Button>
                  ),
                },
              ]}
            />
          </Col>
        </Row>
      </div>
    </TabPane>
  );
}
